import { Movie } from "@/types/Movie"
import axios from "axios"
import { url } from "../helper"
import { defineStore } from "pinia"
import { reactive } from "vue"
import { useI18n } from "vue-i18n"

interface MovieType {
	movies: {
		category: number
		data: Movie[]
	}[]
	heroMovies: Movie[]
	profileMoviesList: {
		category: number
		data: Movie[]
	}[]
	watchingMoviesList: {
		category: number
		data: Movie[]
	}[]
	social: any
	footer_menu: any
	selectedMovie: Movie | null
	selectedMovieTime: number
	hoveredMovieId: number
	hoveredMovieType: string | null
	isHovered: boolean
	top: number
	left: number
}

export const useMovieStore = defineStore("useMovieStore", () => {
	const { locale } = useI18n()
	const state = reactive<MovieType>({
		movies: [],
		heroMovies: [],
		profileMoviesList: [],
		watchingMoviesList: [],
		social: [],
		footer_menu: [],
		selectedMovie: null,
		selectedMovieTime: 0,
		hoveredMovieId: 0,
		hoveredMovieType: null,
		top: 0,
		left: 0,
		isHovered: false,
	})

	const getHeroMovies = async () => {
		try {
			await axios
				.get(
					`${url}/${locale.value}/jsonapi/node/movie?jsonapi_include=1&include=field_trailer_file,field_image,field_hero_image&filter[langcode]=${locale.value}&filter[field_promote_to_hero]=1&sort=-changed`,
					{}
				)
				.then((res) => {
					state.heroMovies = res.data.data
				})
		} catch (error) {
			console.log(error)
		}
	}

	const getSimilarMoviesByCategory = (categoryIds: Array<number | string>, excludeId?: number | string) => {
		if (!categoryIds || categoryIds.length === 0) return []
		// Convert all to strings for comparison
		const categorySet = new Set(categoryIds.map(String))
		return state.movies.filter((m) => {
			if (excludeId && m.drupal_internal__nid === excludeId) return false
			if (!m.field_category) return false
			const movieCategories = Array.isArray(m.field_category) ? m.field_category : [m.field_category]
			// Convert to strings for comparison
			return movieCategories.map(String).some((catId) => categorySet.has(catId))
		})
	}

	const getMoviesByCategory = (id: number) => {
		return state.movies.filter((movie) => {
			const categories = movie.field_category || []
			return categories.some((category) => category.meta?.drupal_internal__target_id === id)
		})
	}

	return { state, getHeroMovies, getMoviesByCategory, getSimilarMoviesByCategory }
})
